function getDependentFilterKeysByKey(key, filters) {
  const filterKeys = [];
  filters.forEach((filter) => {
    var _a;
    const isReset = (_a = filter.resetOnChange) == null ? void 0 : _a.includes(key);
    if (!isReset) {
      return;
    }
    const subDeps = getDependentFilterKeysByKey(filter.key, filters);
    filterKeys.push(filter.key, ...subDeps);
  });
  const uniqueFilterKeys = new Set(filterKeys);
  return Array.from(uniqueFilterKeys.values());
}
export {
  getDependentFilterKeysByKey
};
